import React from "react";
import ComboboxInput from "../Reusable/ComboboxInput";
import APIS from "../../constant/Endpoint";

//@ts-ignore
import { tw } from "@careinfo/tailwind";
const MerchantInvoiceForm = ({
  errors,
  register,
  setValue,
  getValues,
  clearErrors,
}: any) => {
  return (
    <>
      <div className={tw`w-64`}>
        <ComboboxInput
          url={APIS.MERCHANT}
          queryKey={"merchant"}
          register={register("vendor", {
            required: "Vendor Name is required",
          })}
          errors={errors?.vendor}
          name={"vendor"}
          label={"Select Vendor"}
          setValue={setValue}
          placeholder={"Select Vendor"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
      </div>
    </>
  );
};

export default MerchantInvoiceForm;
